"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  preferences: undefined,
  recipientPreferences: undefined,
  preferencePage: undefined
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "preferences/FETCH_RECIPIENT_PREFERENCES/PENDING":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case "preferences/UPDATE_RECIPIENT_PREFERENCES/PENDING":
      return _objectSpread(_objectSpread({}, state), {}, {
        isUpdating: true
      });

    case "preferences/FETCH_PREFERENCE_PAGE/PENDING":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case "preferences/FETCH_DRAFT_PREFERENCE_PAGE/PENDING":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case "preferences/FETCH_RECIPIENT_PREFERENCES/DONE":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          recipientPreferences: action === null || action === void 0 ? void 0 : action.payload
        });
      }

    case "preferences/FETCH_PREFERENCE_PAGE/DONE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        preferencePage: action === null || action === void 0 ? void 0 : action.payload
      });

    case "preferences/FETCH_DRAFT_PREFERENCE_PAGE/DONE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        preferencePage: action === null || action === void 0 ? void 0 : action.payload
      });

    case "preferences/UPDATE_RECIPIENT_PREFERENCES/DONE":
      {
        var _state$recipientPrefe;

        return _objectSpread(_objectSpread({}, state), {}, {
          isUpdating: false,
          recipientPreferences: (_state$recipientPrefe = state.recipientPreferences) === null || _state$recipientPrefe === void 0 ? void 0 : _state$recipientPrefe.map(function (preference) {
            var _action$payload;

            if (preference.templateId === (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.templateId)) {
              return action === null || action === void 0 ? void 0 : action.payload;
            }

            return preference;
          })
        });
      }
  }

  return state;
};

exports["default"] = _default;